import { useQuery, useQueryClient } from '@tanstack/react-query';
import { routerClient } from '../client-rpc-router';
import { buildTerminalStateQueryKey } from '../query-keys';

export const useTerminalState = () => {
	return useQuery({
		queryKey: buildTerminalStateQueryKey(),
		queryFn: () => routerClient.wms.getTerminalStateQuery.execute({})
	});
};

export function useInvalidateTerminalState() {
	const queryClient = useQueryClient();
	return () => queryClient.invalidateQueries({ queryKey: buildTerminalStateQueryKey() });
}
